export enum AuthActionTypes {
    AUTH_INIT = "AUTH_INIT",
    AUTH_REQUEST = "AUTH_REQUEST",
    AUTH_SUCCESS = "AUTH_SUCCESS",
    AUTH_ERROR = "AUTH_ERROR",
    LOGOUT_REQUEST = "LOGOUT_REQUEST"
}
